/* === Flakko ATC loading/added animation (start) === */
(() => {
  const SEL = '.add-to-cart-button:not(.quick-add__button)';
  const HOLD = 1200, MAX_WAIT = 8000;
  const timers = new WeakMap();
  const label = () => (window.Theme && Theme.translations && Theme.translations.added) || 'Added';
  const set = (btn, state) => {
    clearTimeout(timers.get(btn));
    if (!state) { btn.removeAttribute('data-fs-atc'); return; }
    const added = btn.querySelector('.add-to-cart__added');
    if (added) added.setAttribute('data-fs-label', label());
    btn.setAttribute('data-fs-atc', state);
    timers.set(btn, setTimeout(() => set(btn, null), state === 'added' ? HOLD : MAX_WAIT));
  };
  const loading = () => document.querySelectorAll(SEL + '[data-fs-atc="loading"]');
  const finish = ok => loading().forEach(b => set(b, ok ? 'added' : null));
  document.addEventListener('click', e => {
    const btn = e.target.closest && e.target.closest(SEL);
    if (!btn || btn.disabled || btn.getAttribute('aria-disabled') === 'true' || btn.hasAttribute('data-fs-atc')) return;
    set(btn, 'loading');
  }, true);
  document.addEventListener('shopify:cart:lines-update', e => {
    const p = e.promise || (e.detail && e.detail.promise);
    if (p && p.then) p.then(() => finish(true), () => finish(false));
    else setTimeout(() => finish(true), 600);
  }, true);
  document.addEventListener('shopify:cart:error', () => finish(false), true);
})();
/* === Flakko ATC loading/added animation (end) === */

/* === Flakko coupon applied toast (start) === */
(() => {
  if (window.__fsCouponToast) return; window.__fsCouponToast = 1;
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const norm = c => String(c || '').trim().toUpperCase();
  let known = null, busy = null;
  const getCart = () => fetch(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(r => r.json());
  const codesOf = cart => new Set((cart.discount_codes || []).filter(d => d.applicable).map(d => norm(d.code)));
  const savedFor = (cart, code) => {
    let s = 0;
    (cart.cart_level_discount_applications || []).forEach(a => { if (norm(a.title) === code) s += +a.total_allocated_amount || 0; });
    (cart.items || []).forEach(i => (i.line_level_discount_allocations || []).forEach(a => {
      if (a.discount_application && norm(a.discount_application.title) === code) s += +a.amount || 0; }));
    return s || +cart.total_discount || 0;
  };
  const money = (cents, cur) => {
    try { return new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: cur || (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' }).format(cents / 100); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  };
  const show = (code, cents, cur) => {
    document.querySelectorAll('.fs-coupon-toast').forEach(t => t.remove());
    const t = document.createElement('div');
    t.className = 'fs-coupon-toast'; t.setAttribute('role', 'status'); t.setAttribute('aria-live', 'polite');
    t.innerHTML = '<span class="fs-coupon-toast__icon" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M5 12.5l4.2 4.2L19 7"/></svg></span>' +
      '<span class="fs-coupon-toast__text"><strong class="fs-coupon-toast__title">Coupon Applied!</strong>' +
      '<span class="fs-coupon-toast__line"></span></span>';
    t.querySelector('.fs-coupon-toast__line').textContent = 'You saved ' + money(cents, cur) + ' with ' + code;
    document.body.appendChild(t);
    requestAnimationFrame(() => requestAnimationFrame(() => t.classList.add('is-visible')));
    let gone = false;
    const hide = () => { if (gone) return; gone = true; t.classList.remove('is-visible'); t.classList.add('is-leaving'); setTimeout(() => t.remove(), 450); };
    t.addEventListener('click', hide);
    setTimeout(hide, 3200);
  };
  const check = () => {
    if (busy) return busy;
    busy = new Promise(r => setTimeout(r, 250)).then(getCart).then(cart => {
      const now = codesOf(cart);
      if (known) {
        const added = [...now].filter(c => !known.has(c));
        if (added.length) { const c = added[0], cents = savedFor(cart, c); if (cents > 0) show(c, cents, cart.currency); }
      }
      known = now;
    }).catch(() => {}).finally(() => { busy = null; });
    return busy;
  };
  getCart().then(c => { if (!known) known = codesOf(c); }).catch(() => {});
  const of = window.fetch;
  window.fetch = function (input, init) {
    const p = of.apply(this, arguments);
    try {
      const url = typeof input === 'string' ? input : (input && input.url) || '';
      const method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
      if (method !== 'GET' && /\/cart\/(update|change|add)|discount/.test(url)) p.then(() => check()).catch(() => {});
    } catch (e) {}
    return p;
  };
})();
/* === Flakko coupon applied toast (end) === */
